<template>
  <div class="hello">
    <iframe allowFullScreen=true frameborder="0" class="iframeItem"
            id="iframe"
            src="">

    </iframe>
    <v-snackbar
      v-model="snackbar"
      timeout="6000"
      color="red"
      :top="true"
      :vertical="false"
    >
      {{ clientErrorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          关闭
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import $ from 'jquery'
export default {
  data () {
    return {
      config: {
        appliId: '755203173437669376',
        server: 'http://222.128.6.137:8181/',
        webclient: "http://cloudlark.pingxingyun.com:8181/enterAppli"
      },
      timer:null,
      clientErrorMessage:'',
      clientErrorCode:[
        101,// 连接渲染服务器失败
        102,// 与渲染服务器连接关闭
        103,// 与渲染服务器连接出错
        201,// 连接代理服务器失败
        202,// 与代理服务器连接关闭
        203,// 与代理服务器连接出错
        301,// 版本检测失败
        401,// 未发现 Task
        402,// 服务器端错误
        403,// 应用参数错误
        404,// Task 获取成功，但是没有可分配的显卡
        501,// 启动流媒体出错
        502,// 启动流媒体超时
        503,// 启动流媒体未串流
        504,// 启动流媒体编码错误
        601,// RTC 连接关闭
        602,// RTC 连接出错
      ],
      snackbar:false,
      resParams:'&codeRate=20000&frameRate=60&network=0',
      query:null,
    }
  },
  mounted: function () {
    var that = this;
    window.addEventListener("message", function(e) {
      let dataType = e.data.type;
      if(that.clientErrorCode.indexOf(dataType) >= 0 ){
        that.snackbar = true;
        that.clientErrorMessage = e.data.message;
        //that.changeAppli(that.config)
      }
      //920是用户主动点击退出按钮
      if(dataType == 920){
        window.location.href = "https://www.pingxingyun.com/experience/index_3";
      }
    }, false);

    this.GetRequest();
    this.enterApp();
  },
  methods: {
    enterApp() {
      //未登录时，提示使用2min后需要登录
      let that = this;
      console.log(this.query.loginFlag);
      if(this.query.loginFlag == "true") {
          this.timer = setTimeout(function () {
            that.needToLogin();
          },1000*120);
      }
      $("#iframe").attr("src", this.config.webclient + "?appliId="+this.config.appliId + this.resParams);
    },
    needToLogin:function () {
        window.location.href = "https://www.pingxingyun.com/experience/index_3?loginFlag=true"
     // window.location.href = "http://192.168.0.28:8099/experience/index_3?loginFlag=true"
    },
    GetRequest() {
      let url = location.search; //获取url中"?"符后的字串
      let theRequest = new Object();
      if (url.indexOf("?") != -1) {
        url = url.substr(url.indexOf("?"),url.length);
        let str = url.substr(1);
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      this.query = theRequest;
      this.config.appliId = this.query.appliId;
    },
  },
  beforeDestroy: function () {
    $("#iframe").attr("src","");
    clearInterval(this.timer)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #iframe {
    width: -webkit-fill-available;
    /* min-height: -webkit-fill-available; */
    border: 1px solid lightgreen;
    height: 100%;
    background: #ffffff
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue